export default __webpack_public_path__ + "static/media/ded-tools-monday.12209345.svg";